module.exports = __webpack_public_path__ + "img/arrows-from-line.2fc1f54b.svg";